import React, { Component, Fragment } from 'react'
import { Calendar } from "react-modern-calendar-datepicker";
import 'react-modern-calendar-datepicker/lib/DatePicker.css';


export default class ModernCalendar extends Component {
  constructor(props) {
    super(props);
  }


  render() {
    const { headerAccess, rotate, monthYear, swipeAccess, weekAccess } = this.props;
    return (
      <Fragment>
        <Calendar
          shouldHighlightWeekends
          locale="fa" // add this
          headerAccess={headerAccess}
          onChange={value => this.props.setSelectedDay(value)}
          swipeAccess={swipeAccess}
          weekAccess={weekAccess}
          monthYear={monthYear}
          rotate={rotate}
        />
      </Fragment>
    );
  }
}